import { Button, LinkButton } from '@flash-tecnologia/hros-web-ui-v2';
import { RowContainer } from 'components/Containers';
import { FC } from 'react';

export const SubmitFooter: FC<{
  onSubmit?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  loading?: boolean;
  error?: string;
}> = ({ onSubmit, onCancel, loading }) => {
  return (
    <RowContainer
      style={{
        width: '100%',
        height: '80px',
        padding: '15px',
        position: 'sticky',
        bottom: '0',
        background: 'white',
        borderTop: '1px solid #ebe6e9',
        zIndex: '10',
      }}
    >
      <div
        style={{
          width: '50%',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <LinkButton onClick={(e) => onCancel && onCancel(e)} variant="neutral">
          Cancelar
        </LinkButton>
      </div>
      <div
        style={{
          width: '50%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Button
          loading={loading}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onSubmit && onSubmit(e);
          }}
          style={{ width: '198px' }}
          variant="primary"
        >
          Concluir
        </Button>
      </div>
    </RowContainer>
  );
};
